import { axiosInstance } from '../../../services/axiosInstanceService';

async function login(params: { username: string; password: string }) {
  return axiosInstance()
    .post('/login', params)
    .then(
      (result) => {
        const r = result.data;

        if (!r.company) {
          return Promise.reject({ status: 403, message: 'User without company' });
        }

        const parsed: LoginResponseType = {
          userIdIri: '/users/' + r.id,
          companyId: r.company.id,
          token: r.token,
          refreshToken: r.refresh_token,
        };

        return parsed;
      },
      (error) => {
        return Promise.reject(error);
      },
    );
}

export { login };
